import { Map } from 'immutable';
import createSelector from '../../utils/reselect';

const getInbox = (state: any) => {
    const { inbox } = state;
    return inbox || Map();
};

export const getInboxList = createSelector(getInbox, (state) => {
    return state.getIn(['inboxList', 'data']) || [];
});

export const getInboxListLoading = createSelector(getInbox, (state) => {
    return state.getIn(['inboxList', 'loading']);
});

export const getInboxFilterSelections = createSelector(getInbox, (state) => {
    return state.getIn(['inboxFilters', 'filterSelections']);
});

export const getLoadMore = createSelector(getInbox, (state) => {
    return state.getIn(['inboxList', 'loadMore']);
});

export const getInboxCount = createSelector(getInbox, (state) => {
    return state.getIn(['inboxList', 'inboxCount']) || Map();
});

export const getInboxSearchForm = createSelector(getInbox, (state) => {
    return state.getIn(['inboxSearchForm', 'data']);
});

export const getInboxSearchFormLoadingStatus = createSelector(getInbox, (state) => {
    return state.getIn(['inboxSearchForm', 'loading']);
});
